import React from 'react';
import { AimNote, ModuleIdentifier, PropertyPrice } from './AIMApi';
import { UseFormReturnType } from '@mantine/form';

const stateMutationInitialValue = () => {
    return (val: any) => {
        return val;
    };
};

const voidFunctionInitialValue = () => {
    return;
};

/**
 * Holds an entity identifier and a list of files to be uploaded as attachments on that entity.
 */
export interface AimEntityAttachment {
    entity: ModuleIdentifier | undefined;
    attachments: Array<File>;
}

/**
 * Shape of the AIM context value, carrying entity attachment state, notes, and property price selections with their respective state-setters.
 */
export interface AimContextValue {
    entityAttachments: AimEntityAttachment;
    setEntityAttachments: React.Dispatch<React.SetStateAction<AimEntityAttachment>>;
    clearEntityAttachments: () => void;
    entityNotes: AimNote[];
    setEntityNotes: React.Dispatch<React.SetStateAction<AimNote[]>>;
    clearEntityNotes: () => void;
    selectedPropertyPricesNewTransaction: PropertyPrice[];
    handleSetSelectedPropertyPricesNewTransaction: (prices: PropertyPrice[]) => void;
    phaseDataForm?: UseFormReturnType<any>;
    handleSetPhaseDataInitialValues: (values: any) => void;
    selectedPropertyPricesEditTransaction: PropertyPrice[];
    handleSetSelectedPropertyPricesEditTransaction: (prices: PropertyPrice[]) => void;
}

/**
 * Default AIM context value object with empty attachment state, empty notes list, and state-mutation helper functions.
 */
export const initialAimContextValue: AimContextValue = {
    entityAttachments: {
        entity: undefined,
        attachments: []
    },
    setEntityAttachments: stateMutationInitialValue,
    clearEntityAttachments: stateMutationInitialValue,
    entityNotes: [],
    setEntityNotes: stateMutationInitialValue,
    clearEntityNotes: voidFunctionInitialValue,
    selectedPropertyPricesNewTransaction: [],
    handleSetSelectedPropertyPricesNewTransaction: stateMutationInitialValue,
    phaseDataForm: undefined,
    handleSetPhaseDataInitialValues: value => {},
    selectedPropertyPricesEditTransaction: [],
    handleSetSelectedPropertyPricesEditTransaction: stateMutationInitialValue,
};
